<template>
  <div class="container">
    <!-- 输入框 -->
    <div class="content">
      <!-- 绑定手机号码 -->
      <div class="tit">{{ $t('safe').Bindmobilephone }}</div>
      <!-- 手机号-->
      <div class="item">
        <van-field v-model="PhoneNumber" type="tel" :placeholder="$t('register').PhoneNumber">
          <template #left-icon>
            <VueCountryIntl schema="popover" v-model="PhoneNumberCode" :listZIndex="10000" popoverClass="selectCountry" :searchInputPlaceholder="$t('register').searchCountryMsg" @onChange="selectCountry">
              <i class="select_btn" slot="reference" @click="selectCountry">
                <span> +{{ PhoneNumberCode }}</span>
                <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
                <div class="line"></div>
              </i>
            </VueCountryIntl>
          </template>
        </van-field>
      </div>
      <!-- 验证码 -->
      <div class="item">
        <van-field v-model="Captcha" :placeholder="$t('register').Captcha">
          <template #right-icon>
            <span style="color: var(--primary_color)" @click="getCaptchaCode" v-if="countDownSec === 60">{{ tips
            }}</span>
            <span v-else style="color: var(--ntext_color)">{{ countDownSec }} s</span>
          </template>
        </van-field>
      </div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('forgotPass').btn }}</van-button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      PhoneNumberCode: '1', //手机区号
      PhoneNumber: '', //手机号
      Captcha: '', //验证码
      uuid: '',//验证码token
      tips: this.$t('register').send,//发送验证码信息
      countDownSec: 60,
      timer: null,
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // 选择国家区号
    selectCountry() {
      this.$nextTick(() => {
        const searchInput = document.querySelector(
          '.selectCountry .search-input'
        )
        if (searchInput) {
          searchInput.style.width = '90%'
          searchInput.style.height = 'auto'
        }
      })
    },
    //获取验证码
    async getCaptchaCode() {
      if (this.timer) return
      if (this.PhoneNumber == '') {
        this.$toast({
          message: this.$t('register').placeholder0,
          position: 'center'
        })
        return
      }
      this.sendCode()
    },
    //发送验证码
    async sendCode() {
      this.countDownSec--
      this.timer = setInterval(() => {
        this.countDownSec--
        if (this.countDownSec === 0) {
          this.countDownSec = 60
          this.tips = this.$t('register').Resend
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
      const pRes = await userApi.sendCode({
        type: 'Phone',
        phoneNumberCode: '+' + this.PhoneNumberCode,
        phoneNumber: this.PhoneNumber,
      })
      this.$toast({ message: this.$t('register').sendSuccess })
      this.uuid = pRes.uuid
    },
    // 提交
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        phoneNumber: this.PhoneNumber,
        phoneNumberCode: '+' + this.PhoneNumberCode,
        uuid: this.uuid,
        captcha: this.Captcha,
      }
      await userApi.bindPhone(form)
      this.$toast(this.$t('forgotPass').success)
      this.$router.go(-1)
    },
    // 表单验证
    checkForm() {
      if (!this.PhoneNumber) {
        this.$toast({
          message: this.$t('register').placeholder0,
          position: 'center'
        })
        return false
      }
      // 验证码
      if (!this.Captcha) {
        this.$toast({
          message: this.$t('register').placeholder4,
          position: 'center'
        })
        return false
      }
      return true
    }
  }
}
</script>


<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .content {
    margin: 0 auto;
    max-width: 480px;

    .tit {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
      margin-bottom: 50px;
    }

    .item {
      margin-top: 30px;

      .select_btn {
        font-size: 15px;
        color: var(--primary_color);
        margin-right: 10px;
        display: flex;
        align-items: center;

        .ric {
          transform: rotate(90deg);
          margin: 0 10px 0 5px;
        }

        .line {
          height: 15px;
          background: var(--ntext_color);
          width: 1px;
        }
      }
    }

    .van-button {
      margin-top: 30px;
      background: var(--primary_color);
      height: 50px;
      border-radius: 25px;
      border: 0;
      font-size: 16px;
      color: #fff;
    }

    .van-button:hover {
      opacity: 0.8;
    }

    .footer {
      position: fixed;
      bottom: 30px;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
        font-weight: bold;
      }
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 50px;
  margin-bottom: 30px;
  border-radius: 10px;
  font-size: 15px;
  border: 1px solid var(--line_color);
  &:focus-within {
    border: 1px solid var(--primary_color);
    box-shadow: 1px 1px 2px var(--ntext_color);
  }
  &:hover {
    border: 1px solid var(--primary_color);
  }
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 15px;
  opacity: 0.9;
}

::v-deep .van-field__left-icon {
  align-items: center;
  display: flex;
}

::v-deep .van-tab {
  font-size: 15px;
  justify-content: left;
}

::v-deep .van-tab--active {
  font-weight: bold;
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: var(--text_color);
  font-size: 14px;
}
</style>
